import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, inject } from '@angular/core'
import { Subject } from 'rxjs'
import {
  DataContextBuilder,
  IDataContext,
  Sort,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderDataToolbarComponent,
  ElderToolbarContentDirective,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderSearchPanelComponent,
  ElderNumberCellDirective,
  ElderQuantityPipe,
  ElderSinglePaneWrapperComponent,
} from '@elderbyte/ngx-starter'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ActivatedRoute, Router } from '@angular/router'
import { FacilityService } from '../../../facilities/facility.service'
import { StorageGroup } from '../storage-group'
import { StorageGroupService } from '../storage-group.service'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { DatePipe } from '@angular/common'
import {
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
} from '@angular/material/table'
import { MatSort, MatSortHeader } from '@angular/material/sort'

@Component({
  selector: 'app-storage-group-browser',
  templateUrl: './storage-group-browser.component.html',
  styleUrls: ['./storage-group-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    ElderSearchPanelComponent,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    ElderNumberCellDirective,
    DatePipe,
    ElderTranslatePipe,
    ElderQuantityPipe,
    ElderSinglePaneWrapperComponent,
  ],
})
export class StorageGroupBrowserComponent implements OnInit, OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly unsubscribe$ = new Subject<void>()

  public readonly data: IDataContext<StorageGroup>

  @Input()
  public float: boolean

  @Input()
  public embedded: boolean

  private router = inject(Router)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const storageGroupService = inject(StorageGroupService)

    this.data = DataContextBuilder.start<StorageGroup>()
      .reloadOnLocalChanges()
      .build(storageGroupService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    this.data.start([new Sort('createdAt', 'desc')], this.data.filter.filtersSnapshot)
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()

    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  /**
   * Occurs when an item in the browser is clicked.
   */
  public onItemClick(group: StorageGroup): void {
    if (group) {
      this.router.navigate([
        {
          outlets: {
            side: ['storageGroups', group.id],
          },
        },
      ])
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/
}
